import { useEffect, useRef, useState } from 'react'
import { cn } from '@/lib/utils'
import { ADS_ENABLED } from '@/lib/google-ads'
import { ensureExoclickScript, getExoclickStatus, subscribeToExoclickStatus } from '@/lib/exoclick-ads'

export interface ExoclickStickyBannerProps {
  className?: string
}

export function ExoclickStickyBanner({ className }: ExoclickStickyBannerProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const didPush = useRef(false)
  const [status, setStatus] = useState(getExoclickStatus())

  useEffect(() => {
    if (!ADS_ENABLED) return

    const unsubscribe = subscribeToExoclickStatus((newStatus) => {
      setStatus(newStatus)
    })

    ensureExoclickScript()

    // Push serve instruction once when component mounts
    if (!didPush.current) {
      didPush.current = true
      try {
        ;(window.AdProvider = window.AdProvider || []).push({ serve: {} })
      } catch (e) {
        console.error('Exoclick sticky banner push error:', e)
        didPush.current = false
      }
    }

    return () => {
      unsubscribe()
    }
  }, [])

  if (!ADS_ENABLED || status.isBlocked) return null

  return (
    <div 
      ref={containerRef} 
      className={cn(
        'exoclick-sticky-banner-scope fixed bottom-6 right-6 z-[9999] flex justify-center items-center pointer-events-none [&>*]:pointer-events-auto', 
        className
      )}
      style={{ minWidth: '300px', minHeight: '50px' }}
    >
      <ins 
        className="eas6a97888e17" 
        data-zoneid="5943578" 
        style={{ display: 'inline-block', width: '300px', height: '50px' }}
      />
    </div>
  )
}
